<template>
	<b-card no-body class="p-3" :class="(is_deleted ? 'archived-section' : '')">
		<EditCase ref="drawer_edit_case" />
		<b-row align-v="center" class="d-flex align-items-center">
			<b-col lg="auto" class="border-right">
				<p class="text-muted text-xs">Ref No:</p>
				<p class="font-weight-600 text-primary">{{ activeCase.case_no || '-' }}</p>
				<span class="badge bg-gray text-white font-weight-400">{{ activeCase.loan_type_name }}</span>
			</b-col>
			<b-col>
				<p class="text-muted text-xs">Status</p>
				<el-dropdown trigger="click" v-model="status_id" style="cursor: pointer;" @command="updateCaseStatus">
					<p class="el-dropdown-link top-line">
						<span class="d-inline-block text-truncate" style="max-width: 150px; overflow: unset;"
						:class="currentStatus.color_class">{{ currentStatus.name }}</span>
						<i class="el-icon-caret-bottom el-icon--right"></i>
					</p>
					<el-dropdown-menu slot="dropdown">
						<div style="max-height: 300px;overflow-y: auto;">
							<el-dropdown-item v-for="(status, index) in statusList" :key="index" :command="status">{{ status.name }}</el-dropdown-item>
						</div>
					</el-dropdown-menu>
				</el-dropdown>
				<!-- <p class="text-muted text-xs">Status</p>
				<div class="d-flex align-items-center">
					<p class="text-warning">LO-Presign</p>
					<svg xmlns="http://www.w3.org/2000/svg" class="ml-3" width="8" height="20" viewBox="0 0 320 512">
						<path fill="#73839C"
							d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S301 191.9 288 191.9L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
					</svg>
				</div> -->
			</b-col>
			<b-col>
				<p class="text-muted text-xs">Loan Amount</p>
				<p class="font-weight-600">RM {{ activeCase.loan_amount | moneyFormatter }}</p>
			</b-col>
			<b-col>
				<p class="text-muted text-xs">Total Interest Amt. (Tenure)</p>
				<span class="font-weight-600">RM {{ activeCase.total_interest_amt | moneyFormatter }}</span>
				<span class="bottom-line"> ({{ activeCase.loan_tenure || '0' }} {{ activeCase.loan_tenure_period || '-' }})</span>
			</b-col>
			<b-col>
				<p class="text-muted text-xs">Instalment Amount</p>
				<p class="font-weight-600">RM {{ activeCase.installment_amount | moneyFormatter }}</p>
			</b-col>
			<b-col>
				<div class="d-flex align-items-center text-primary float-right cursor-pointer"
					@click="$refs.drawer_edit_case.viewEditCase()">
					<p class="text-primary">View Details</p>
					<svg xmlns="http://www.w3.org/2000/svg" class="ml-1" width="8" height="20" viewBox="0 0 320 512">
						<path fill="currentColor"
							d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
					</svg>
				</div>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import { DropdownMenu, DropdownItem, Dropdown } from 'element-ui'
import EditCase from '@/views/CreditLoanCase/Drawers/DrawerEditCase/EditCase'
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useCommonStore } from '@/stores/commonStore';
// import { useApprovalStore } from '@/stores/approvalStore';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'

export default {
	components: {
		EditCase,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
	},
	data() {
		return {
			currentStatus: {},
			statusList: [],
			status_id: null
		}
	},
	created() {
		this.setStatusList();
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase']),
		...mapState(useCommonStore, ['allStatus']),
		// getTenurePeriod() {
		// 	return this.getLoanType(this.activeCase.loan_type_id)?.loan_tenure_period;
		// }
		is_deleted(){
			return !_gHlp.isEmpty(this.activeCase.deleted_at);
		}
	},
	watch: {
		'activeCase': {
			handler(newValue, oldValue) {
				this.status_id = newValue.status_id
				this.setStatusList()
			},
			immediate: true
		},
		'allStatus': {
			handler(newValue, oldValue) {
				this.setStatusList()
			},
			immediate: true
		}
	},
	methods: {
		// ...mapActions(useApprovalStore, ['createApproval']),
		...mapActions(useCommonStore, ['getLoanType']),
		...mapActions(useLoanCaseStore, ['updateCase']),
		setStatusList() {
			if (!_gHlp.isEmpty(this.allStatus)) {
				this.statusList = this.allStatus.filter(itm => (itm.module == 'case' && itm.parent_id > 0));
				this.setCurrentStatus();
			}
		},
		setCurrentStatus() {
			if (!_gHlp.isEmpty(this.allStatus) && !_gHlp.isEmpty(this.status_id)) {
				this.currentStatus = this.allStatus.find(itm => itm.id == this.status_id);
			}
			if (_gHlp.isEmpty(this.currentStatus)) {
				this.currentStatus = { id: null, name: "No Status", color_class: "text-grey" }
			}
		},
		updateCaseStatus(val){
			this.status_id = val.id
			this.setStatusList()
			this.updateCase({status_id:this.status_id}).then(res => {
				_gNotif.notifySuccess("Case status has been update")
			});
		}
	},
}
</script>